import { Box, IconButton, SxProps, Theme } from "@mui/material";
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import { useAppDispatch, useAppSelector } from "../../redux/store";
import { toggleTheme } from "../../redux/features/themeSlice";
import { FC } from "react";


interface ButtonToggleThemeProps {
    sx?: SxProps<Theme>
}


const ButtonToggleTheme:FC<ButtonToggleThemeProps> = ({sx}) => {

    const theme = useAppSelector(state => state.theme)
    const dispatch = useAppDispatch()
    
    

    return (
        <Box
            sx={{
                display: 'flex',
                width: '100%',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: 1,
               
                ...sx
            }}
        >
            <IconButton sx={{ ml: 1 }}  onClick={() => dispatch(toggleTheme())}>
                {theme.darkTheme ? <Brightness7Icon /> : <Brightness4Icon />}
            </IconButton>
        </Box>

    );
}

export default ButtonToggleTheme;